import { useQuery } from '@tanstack/react-query';
import { fetchProductCapabilities } from '../services/products';

export const useProductCapabilitiesQuery = () =>
    useQuery({
        queryKey: ['smr', 'product-capabilities'],
        queryFn: fetchProductCapabilities,
        staleTime: 30 * 60 * 1000,
    });
